<div class="modal-body text-center">
  <p *ngIf="!isInnerHTML" class="mb-0">{{content}}</p>
  <div *ngIf="isInnerHTML" [innerHTML]="content"></div>
</div>
